import React, { useState } from 'react';
import ReactDOM from "react-dom";
//import { Grid, Dialog, DialogContent, DialogActions, Button } from '@material-ui/core';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


/*const createPromise = () => {
  let resolver;
  return [ new Promise(( resolve, reject ) => {
    resolver = resolve
  }), resolver]
}


const useConfirm = () => {
  const [ open, setOpen ] = useState(false);
  const [ resolver, setResolver ] = useState({ resolver: null })
  const [ label, setLabel ] = useState('')
  
  const getConfirmation = async (text) => {
    setLabel(text);
    setOpen(true);
    const [ promise, resolve ] = await createPromise()
    setResolver({ resolve })
    return promise;
  }

  const onClick = async(status) => {
    setOpen(false);
    resolver.resolve(status)
  }

  const Confirmation = () => (
    <>
    <Modal show={open} onHide={()=>onClick(0)}>
        <Modal.Header closeButton>
          <Modal.Title>Permanment Change</Modal.Title>
        </Modal.Header>
        <Modal.Body>{label}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={()=>onClick(1)}>
            Yes
          </Button>
          <Button variant="primary" onClick={()=>onClick(2)}>
            No
          </Button>
          <Button variant="secondary" onClick={()=>onClick(0)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

    {/*<Dialog open={open}>
      <DialogContent>
        {label}
      </DialogContent>
      <DialogActions>
        <Button onClick={ () => onClick(false)}> Cancel </Button>
        <Button onClick={ () => onClick(true)}> OK </Button>
      </DialogActions>
    </Dialog>}
    </>
  )

  return [ getConfirmation, Confirmation ]
    
}

export default useConfirm;*/


function GetValue({ resolve, initialLabel = 0, avatar, title, start_existing, start_new }) {
  
  const [ open, setOpen ] = useState(true);
  //const [ resolver, setResolver ] = useState({ resolver: null })
  const [ label, setLabel ] = useState(initialLabel);

  //const [value, setValue] = React.useState(initialValue);

  /*const getConfirmation = async (text) => {
    setLabel(text);
    setOpen(true);
    //const [ promise, resolve ] = await createPromise()
    //setResolver({ resolve })
    //return promise;
  }*/

  /*function clickPlus() {
    setValue(value => value + 1);
  }
  function clickMinus() {
    setValue(value => value - 1);
  }
  function clickOK() {
    removeDialog();
    resolve({ ok: true, value });
  }
  function clickCancel() {
    removeDialog();
    resolve({ ok: false });
  }*/

  const onClick = async(status) => {
    setOpen(false);
    resolve(status)
  }

  return (
    <Modal show={open} onHide={()=>onClick(0)} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>Permanent Change</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="gx-0">
          <Col xs={12}>
            {label}
            <hr />
          </Col>
          <Col xs={12} className="d-flex align-items-center my-2">
            <div className="avatar avatar-md">
              <img src={avatar} />
            </div>
            <div className="ms-2">
              {title}<br />
              {moment(start_existing*1000).format('DD MMM YYYY @ HH:mm')} ---> {moment(start_new*1000).format('DD MMM YYYY @ HH:mm')}
            </div>
          </Col>
          <Col xs={12}>
            <hr />
            Yes: Select yes to permanently change this booking.<br />
            No: Only to change this schedule booking and return to default for the next upcoming booking.<br />
            Cancel: cancel this change and return to default.
          </Col>
        </Row>
        

      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={()=>onClick(2)} size="sm">
          Yes
        </Button>
        <Button variant="primary" onClick={()=>onClick(1)} size="sm">
          No
        </Button>
        <Button variant="secondary" onClick={()=>onClick(0)} size="sm">
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default function getValue(label, avatar, title, start_existing, start_new) {
  return new Promise((resolve, reject) => {
    addDialog(label, avatar, title, start_existing, start_new, resolve);
  });
}

function addDialog(label, avatar, title, start_existing, start_new, resolve) {
  const body = document.getElementsByTagName("body")[0];
  const div = document.createElement("div");
  div.setAttribute("id", "getValue-container");
  body.appendChild(div);
  ReactDOM.render(
    <GetValue initialLabel={label} avatar={avatar} title={title} start_existing={start_existing} start_new={start_new} resolve={resolve} />,
    div
  );
}

function removeDialog() {
  const div = document.getElementById("getValue-container");
  const body = document.getElementsByTagName("body")[0];
  body.removeChild(div);
}